import {
  ActivityInstance,
  ActivityInstanceStatus,
  ActivityThread,
  ActivityThreadStatus,
  UpdateActivityInstanceStateAddendum
} from '@things-factory/worklist'
import { DataOoc, DataOocStatus } from '../service/data-ooc/data-ooc.js'

async function callback(
  activityInstance: ActivityInstance,
  addendum: UpdateActivityInstanceStateAddendum,
  context: ResolverContext
) {
  const { tx, user, domain } = context.state
  const { id, input, output, state, terminatedAt } = activityInstance
  const { causedBy } = addendum || {}

  /* Resolve Activity가 완료되면, 해당 data-ooc 엔티티의 correctiveAction, correctorId, correctedAt 을 update한다. */
  if (state == ActivityInstanceStatus.Ended) {
    const activityThreads = await tx.getRepository(ActivityThread).find({
      where: {
        domain: { id: domain.id },
        activityInstance: { id },
        state: ActivityThreadStatus.Ended
      },
      relations: ['assignee']
    })

    const corrector = activityThreads[0]?.assignee

    const { dataOocId } = input
    const correctiveAction = output?.action

    var dataOoc = await tx.getRepository(DataOoc).findOne({
      where: {
        domain: { id: domain.id },
        id: dataOocId
      },
      relations: ['dataSet']
    })

    /* dataOoc Review 결과를 dataOoc 엔티티에 반영한다. */
    dataOoc = await tx.getRepository(DataOoc).save({
      ...dataOoc,
      correctedAt: terminatedAt,
      corrector: corrector,
      correctiveAction,
      updater: user,
      state: DataOocStatus.CORRECTED
    })
  }
}

export const ActivityOocResolve = {
  name: 'OOC Resolve',
  description: 'Task to take remedial action based on Out Of Control data',
  release: '1.0.0',
  provider: 'hatiolab.com',
  category: 'quality',
  activityType: 'user',
  priority: 3,
  searchKeys: [
    {
      name: 'dataOocId',
      description: 'OOC Id.',
      inputKey: 'dataOocId',
      tKey: 'data-ooc-id'
    }
  ],
  startingType: '',
  multiple: 'single',
  model: [
    {
      name: 'dataOocId',
      description: 'OOC id',
      tag: 'dataOocId',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    },
    {
      name: 'instruction',
      description: 'Instructions for resolving OOC',
      tag: 'instruction',
      hidden: false,
      mandatory: true,
      inout: 'in',
      type: 'textarea',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    },
    {
      name: 'action',
      description: 'Action Description',
      tag: 'action',
      hidden: false,
      mandatory: true,
      inout: 'out',
      type: 'textarea',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    }
  ],
  uiType: 'custom-element',
  uiSource: 'activity-ooc-resolve-edit',
  viewType: 'custom-element',
  viewSource: 'activity-ooc-resolve-view',
  reportType: 'custom-element',
  reportSource: 'data-ooc-report-page',
  thumbnail: '/assets/images/ooc.png',
  standardTime: 24 * 60 * 60, // seconds
  callback /* Called when there is a change in the lifecycle of a task (activity-instance). */
}
